import { SetupHeaderEntity } from '../PointOfSale/SetupHeaderEntity';
import { POHeadApprovalStatus, PurchaseOrderDetailEntity, PurchaseOrderDetailsEntity } from './PurchaseOrderDetailEntity';
import { PurchaseOrderEntity } from './PurchaseOrderEntity';

export class PurchaseOrderHeaderEntity {
  HeaderId: number;
  Buyer: string;
  SupplierId: number;
  Attention: string;
  DeliverTo: string;
  PurchaseOrderNumber: string;
  Remarks: string;
  DeliveryDate: string;
  LocationId: string;
  FileAttachment: string;
  Reason: string;
  MLTotal: string;
  POTotalDesc: string;
  MiscTotal: string;
  UnAssigned: string;
  PostDate: Date;
  Reference: string;
  ApprovalStatus: number;
  ApprovedBy: string;
  RecommendedSupplierId: number;
  CurrentApprovalLevel: number;
  BumpLevel: number;
  EnteredBy: string;
  EnteredOn: Date;
  Location2: number;
  PrchaseOoderId: number;
  RequestingLocationId: number;
  MaximumApprovalRequired: number;
  History: string;
  Memo: string;
  DepartmentId: number;
  Company2: number;
  Subject: string;
  Valued: number;
  PouserName: string;
  ApprovalStatusId: string;
  Remark1: string;
  ItemId: number;
  DepartmentName: string;
  NextApproverId: number;
  SiteId: number;
  NextApproverName: string;
  RevisionNumber: number;
  RevisionDesc: string;
  ShipVia: string;
  Region: string;
  Office: string;
  Other3: string;
  Other4: string;
  Other5: string;
  SourceReference: string;
  DivisionId: number;
  PoTotal: number;
  Status: number;
  JobNumber: number;
  InvoiceCurrency: number;
  MarketListId: number;
  Position: number;
  GroupNumber: number;
  CancelDate: Date;
  SentOn: Date;
  Distro: number;
  SentVia: number;
  Sent: number;
  CustomerId: number;
  SetupHeaderDetail: SetupHeaderEntity;
  UnitCode: string;
  Conversion: number;
  PuchaseQuantity: number;
  ReceivedQuantity: number;
  ApprovedValue: number;
  LocationName: string;
  SupplierName: string;
  TotalItems: number;
  IsOffline: boolean;
  deliveryDate: any;
  deliveryLocation: any;
  supplier: any;
  PurchaseOrderHeadLocation: POHeadLocation;
  PurchaseOrderHeadCapex: PurchaseOrderHeadCapex;
  PRHeadLocId ?: POHeadLocation;
  POHeadSupplierId: POHeadSupplier;
  ApprovalStatusName: string;
  POHeadApprovalStatusId: POHeadApprovalStatus;
  Remark: string;
  Id: number;
  checked ?: boolean;
  to : any;
  from ?:any;
  id: any;
  date: any;
  timestamp: any;
  items: any;
  price: any;
  TransTypeId: any;
  TransactionStatusId: any;
  poHeaderId: number;
  showSync ?: boolean;
  showCancel ?: boolean;
  PurchaseOrderDetails: Array<PurchaseOrderDetailEntity>;
  VersionNo : number;
  statusText: string;
  PurchaseReqHeadId: any;
  ReqHeadId: any;
  status: any;
  IsSaveAllowed: boolean;
  ResponseMessage: string
  BaseCurrencyId:any;
  TransactionCurrencyId:any;
  ExchangeRate: any;
  CapexId?: any;
  projectExpensed?: boolean;
  AllowChange?: boolean;
  AllowCancel?: boolean;
  ItemCounts: number;
  TransactionMiscCharges?:any;
  POItemTotalInFC: any;
  POItemTotalInFc: any;
  MiscTotalInFC: any;
  isConsignment?: boolean;
  IsConsignment?: boolean;
  approvalStatusId?: string;
  SaveVersion?: number;
  AutoSaveSessionKey?: string;
  EnablePOSelect?: boolean;
  showMore?: boolean;
}

export class POHeadLocation {
  Id: number;
  Name: string;
}

export class PurchaseOrderHeadCapex {
  Id: number;
  Name: string;
}
export class POHeadSupplier{
  Id: number;
  Name: string;
  SupplierSitesAccConfig: any;
}


